export const environment = {
  production: true,
  cpmBaseUrl: 'https://cpmapi.set.or.th/api',
  setLoginUrl: 'https://setlogin.set.or.th'
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/environments/environment.ts